export enum AlertType {
  Member = 'user',
  Item = 'item',
  Conversation = 'msg_thread',
}
